export const OPTIONAL_VIDEO_PROMPT_INDEXES_KEY = 'optionalVideoPromptIndexes'

export const getOptionalVideoPromptIndexes = (displaySetting: any): number[] => {
  const indexes = displaySetting?.[OPTIONAL_VIDEO_PROMPT_INDEXES_KEY]

  if (!Array.isArray(indexes)) return []

  return indexes
    .map((index) => Number(index))
    .filter((index) => Number.isInteger(index) && index >= 0)
    .filter((index, position, values) => values.indexOf(index) === position)
    .sort((left, right) => left - right)
}

export const isVideoPromptRequired = (displaySetting: any, promptIndex: number): boolean =>
  !getOptionalVideoPromptIndexes(displaySetting).includes(promptIndex)

export const setVideoPromptRequired = (displaySetting: any, promptIndex: number, required: boolean) => {
  const optionalIndexes = getOptionalVideoPromptIndexes(displaySetting)
  const nextOptionalIndexes = required
    ? optionalIndexes.filter((index) => index !== promptIndex)
    : [...optionalIndexes, promptIndex].filter((index, position, values) => values.indexOf(index) === position)

  return {
    ...(displaySetting || {}),
    [OPTIONAL_VIDEO_PROMPT_INDEXES_KEY]: nextOptionalIndexes.sort((left, right) => left - right),
  }
}

export const trimOptionalVideoPromptIndexes = (displaySetting: any, promptCount: number) => ({
  ...(displaySetting || {}),
  [OPTIONAL_VIDEO_PROMPT_INDEXES_KEY]: getOptionalVideoPromptIndexes(displaySetting).filter(
    (index) => index < promptCount
  ),
})

const normalizeQuestionText = (value: unknown) =>
  String(value || '')
    .toLocaleLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, ' ')
    .trim()

export interface DuplicateVideoPromptField {
  promptIndex: number
  promptText: string
  fieldText: string
}

export const findDuplicateVideoPromptFields = (
  prompts: string[],
  contributorFields: Array<{ text?: string }>
): DuplicateVideoPromptField[] => {
  const fieldsByNormalizedText = new Map(
    contributorFields
      .map((field) => [normalizeQuestionText(field.text), String(field.text || '')] as const)
      .filter(([normalized]) => !!normalized)
  )

  return prompts.flatMap((promptText, promptIndex) => {
    const fieldText = fieldsByNormalizedText.get(normalizeQuestionText(promptText))
    return fieldText ? [{ promptIndex, promptText, fieldText }] : []
  })
}
